import { faCircleCheck, faCircleXmark } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

const SendNotifications = ({ checked, handleChange }) => {
  return (
    <label
      className={`cursor-pointer flex w-fit items-center justify-between px-3 py-2 gap-1.5 rounded border transition-all ${
        checked
          ? 'bg-green-500/15 hover:bg-green-500/25 border-green-500/50'
          : 'bg-red-500/15 hover:bg-red-500/25 border-red-500/50'
      }`}
    >
      <p className="select-none">Send Omnichannel Notifications</p>
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        className="hidden"
      />
      <p className="sr-only">{checked ? `on` : `off`}</p>
      <FontAwesomeIcon
        icon={checked ? faCircleCheck : faCircleXmark}
        className={`${checked ? 'text-green-500' : 'text-red-500'}`}
      />
    </label>
  )
}

SendNotifications.propTypes = {
  checked: PropTypes.bool,
  handleChange: PropTypes.func
}

export default SendNotifications
